/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {motion} from "motion/react";


class ButtonSkelet extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false
        }
    }

    render() {
        let {onClick, onKeyDown, className = "", children, style = {}, id} = this.props
        let {isLoading} = this.state
        let hasLoading = (typeof children === 'function')

        return (
            <>
                <motion.button whileTap={{scale: 0.9}}
                               type="button"
                               id={id}
                               style={style}
                               onKeyDown={(event) => {
                                   if (onKeyDown !== undefined) {
                                       onKeyDown(event)
                                   }
                               }}
                               onClick={async (event) => {
                                   if (hasLoading) {
                                       if (onClick !== undefined && !isLoading) {
                                           this.setState({isLoading: true})
                                           await onClick(event)
                                           this.setState({isLoading: false})
                                       }
                                   } else {
                                       await onClick(event)
                                   }
                               }}
                               className={className}
                >
                    {hasLoading ? (children(isLoading)) : (children)}
                </motion.button>
            </>
        );
    }
}

ButtonSkelet.propTypes = {};

ButtonSkelet.defaultProps = {};


export default ButtonSkelet;